import { Box, Typography } from '@mui/material';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import Button from 'packages/novous_web/src/common/components/Button';
import CustomDropDownInput from 'packages/novous_web/src/common/components/customDropDownInput';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import InputField from 'packages/novous_web/src/common/components/InputField';
import TimeField from 'packages/novous_web/src/common/components/TimeField';
import React, { useEffect, useState } from 'react';
import { setTime } from 'react-datepicker/dist/date_utils';
import FeatureSection from '../common/FeatureSection';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import Loader from 'packages/novous_web/src/common/components/Loader';

interface CompanyData {
  id: string;
  name: string;
  description: string;
  type: string;
  crn: string;
  address: {
    fullAddress: string;
    city: string;
    state: string;
    pincode: number;
    country: string;
  };
  contacts: {
    telephoneNo: string;
    mobileNo: string;
    email: string;
  };
  url: string;
  status: number;
  deviceTypes: string[] | null;
}
interface UserAlertSettingsProps {
  isSave: boolean;
  handleDisabled: (value: boolean) => void;
  setSave: (value: boolean) => void;
  isFetchAgain: boolean;
  selectedCompany?: any;
  selectedUser?: any;
}

type SettingData = {
  [key: string]: {
    name: string;
    fields: {
      [key: string]: [string, any];
    };
    enableFlag: boolean;
    authenticatedUSerEnabled: boolean;
  };
};

const UserAlertSettings = ({
  isSave,
  isFetchAgain,
  handleDisabled,
  setSave,
  selectedCompany,
  selectedUser,
}: UserAlertSettingsProps) => {
  const [settingData, setSettingData] = useState<SettingData>({});
  const [intialData, setInitialData] = useState<SettingData>({});
  const { user } = useAuth();
  const [toast, setToast] = useState({ open: false, message: '', type: 'error' });
  const isSuperAdmin = user?.authorities === 'ROLE_SUPER_ADMIN';

  const {
    data: UserSettingDataData,
    error: UserSettingDataError,
    loading: UserSettingDataLoading,
    fetchData: UserSettingDataRequestData,
  } = useAxios<any>(API_ENDPOINTS.users.USER_SETTINGS_DATA, 'GET');

  const {
    data: UserSettingFetchData,
    error: UserSettingFetchError,
    loading: UserSettingFetchLoading,
    fetchData: UserSettingFetchRequestData,
  } = useAxios<any>(API_ENDPOINTS.users.USER_SETTINGS_FETCH, 'POST');

  const {
    data: UserSettingDataSave,
    error: UserSettingDataSaveError,
    loading: UserSettingDataSaveLoading,
    fetchData: fetchUserSettingDataSaveData,
  } = useAxios<any>(`${API_ENDPOINTS.users.USER_SETTING_SAVE}`, 'POST');

  useEffect(() => {
    UserSettingFetchRequestData({
      fleetId: user?.authorities === 'ROLE_SUPER_ADMIN' ? user?.id : user?.customer_id,
    });
    console.info(selectedUser, 'calleed here12');

    UserSettingDataRequestData();
  }, []);

  useEffect(() => {
    if (selectedCompany && selectedUser) {
      if (user?.authorities === 'ROLE_SUPER_ADMIN') {
        handleDisabled(false);
      }
      console.info(selectedUser, 'calleed here123');
      UserSettingFetchRequestData({
        fleetId: user?.authorities === 'ROLE_SUPER_ADMIN' ? selectedUser?.id : user?.customer_id,
      });
    }
  }, [selectedUser, isFetchAgain]);

  useEffect(() => {
    if (UserSettingDataSave) {
      setSave(false);
      setToast({
        open: true,
        message: 'User Settings Saved Successfully',
        type: 'success',
      });
    }
  }, [UserSettingDataSave]);

  useEffect(() => {
    if (!UserSettingDataData || !UserSettingFetchData) return;

    const featureTypeData: any = {};

    Object.entries(UserSettingDataData?.data ?? {}).forEach(([key, item]: [string, any]) => {
      if (!item) return;

      featureTypeData[key] = {
        name: item.name,
        fields: {},
      };

      if (Array.isArray(item.fields)) {
        item.fields.forEach((field: any) => {
          if (field.name === 'enableFlag') return;
          let type = field.type;
          if (field.name?.includes('Time')) {
            type = 'time';
          }
          featureTypeData[key].fields[field.name] = [type, null];
        });
      }
    });

    Object.keys(featureTypeData).forEach((key: string) => {
      const nameParts = featureTypeData[key].name.split('_');
      const formattedName = nameParts
        .map((word: string, i: number) => (i === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
        .join('');

      featureTypeData[key].name = formattedName;

      const userData = UserSettingFetchData.data?.[formattedName];
      if (!userData) {
        // Set default OFF values
        featureTypeData[key].enableFlag = false;
        featureTypeData[key].authenticatedUSerEnabled = false;
      } else {
        featureTypeData[key].enableFlag = userData.enableFlag;
        featureTypeData[key].authenticatedUSerEnabled = userData.authenticatedUSerEnabled;

        Object.keys(featureTypeData[key].fields).forEach((fieldName) => {
          if (userData[fieldName] !== undefined) {
            featureTypeData[key].fields[fieldName][1] = userData[fieldName];
          }
        });
      }

      if (user?.authorities === 'ROLE_SUPER_ADMIN') {
        featureTypeData[key].authenticatedUSerEnabled = featureTypeData[key].authenticatedUSerEnabled ?? true;
      }
    });

    setSettingData(featureTypeData);
    setInitialData(featureTypeData);
  }, [UserSettingDataData, UserSettingFetchData]);

  const toggleFeatureFlag = (featureKey: string, flagType: 'enableFlag' | 'authenticatedUSerEnabled') => {
    setSettingData((prev: any) => {
      if (!prev[featureKey]) return prev;

      return {
        ...prev,
        [featureKey]: {
          ...prev[featureKey],
          [flagType]: !prev[featureKey][flagType],
        },
      };
    });
  };

  useEffect(() => {
    if (UserSettingDataSaveError || UserSettingDataError || UserSettingFetchError) {
      setToast({
        open: true,
        message: 'Some Error Occured',
        type: 'error',
      });
    }
  }, [UserSettingDataSaveError, UserSettingDataError, UserSettingFetchError]);

  useEffect(() => {
    if (isSave) {
      handleSave();
    }
  }, [isSave]);

  const updateFieldValue = (featureKey: string, fieldName: string, newValue: any) => {
    console.info(featureKey, fieldName, newValue, 'yashu logic');

    setSettingData((prev: any) => {
      // normalize function: remove _ and lowercase
      const normalize = (str: string) => str.replace(/_/g, '').toLowerCase();

      // Find matching key in prev object
      const matchedKey = Object.keys(prev).find((key) => normalize(prev[key].name) === normalize(featureKey));

      if (!matchedKey || !prev[matchedKey].fields[fieldName]) return prev;

      return {
        ...prev,
        [matchedKey]: {
          ...prev[matchedKey],
          fields: {
            ...prev[matchedKey].fields,
            [fieldName]: [prev[matchedKey].fields[fieldName][0], newValue],
          },
        },
      };
    });
  };

  const hasChanges = (): boolean => {
    // if keys have changed (feature added/removed)
    const current = settingData;
    const initial = intialData;
    const initialKeys = Object.keys(initial);
    const currentKeys = Object.keys(current);
    if (initialKeys.length !== currentKeys.length) return true;

    for (const key of initialKeys) {
      const initialFeature = initial[key];
      const currentFeature = current[key];

      if (!currentFeature) return true; // feature removed

      if (
        initialFeature.enableFlag !== currentFeature.enableFlag ||
        initialFeature.authenticatedUSerEnabled !== currentFeature.authenticatedUSerEnabled
      ) {
        return true;
      }

      const initialFields = initialFeature.fields;
      const currentFields = currentFeature.fields;

      // check if field keys differ
      if (Object.keys(initialFields).length !== Object.keys(currentFields).length) return true;

      for (const fieldKey of Object.keys(initialFields)) {
        const initialValue = initialFields[fieldKey][1];
        const currentValue = currentFields[fieldKey]?.[1];

        if (initialValue !== currentValue) {
          return true;
        }
      }
    }

    return false; // no changes detected
  };

  const handleSave = () => {
    if (!hasChanges()) {
      return;
    }

    const fleetId = user.authorities === 'ROLE_SUPER_ADMIN' ? selectedUser?.id : user?.customer_id;
    if (user.authorities === 'ROLE_SUPER_ADMIN') {
      if (!selectedCompany && !selectedUser) {
        handleDisabled(true);
        setToast({
          open: true,
          message: 'Please select company and user',
          type: 'error',
        });
      } else {
        handleDisabled(false);
      }
    }
    const convertTo24HourFormat = (timeStr: string) => {
      if (!timeStr) return '';

      // Check if already in 24-hour format (contains no AM/PM)
      if (!timeStr.includes('AM') && !timeStr.includes('PM')) {
        return timeStr;
      }

      const [time, period] = timeStr.split(' ');
      let [hours, minutes] = time.split(':').map(Number);

      if (period === 'PM' && hours < 12) {
        hours += 12;
      } else if (period === 'AM' && hours === 12) {
        hours = 0;
      }

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    };
    // Map and filter features to only enabled ones
    const featureList = Object.keys(settingData).map((featureType) => {
      const featureData = settingData[featureType];

      const feature: any = {
        enableFlag: featureData.enableFlag,
        authenticatedUSerEnabled:
          user?.authorities === 'ROLE_SUPER_ADMIN'
            ? featureData.enableFlag
            : featureData.authenticatedUSerEnabled,
      };

      Object.keys(featureData.fields).forEach((fieldName) => {
        console.info(fieldName, 'knckdnckdnckdcnkdnc');
        let fieldValue = featureData.fields[fieldName][1];
        if (fieldName === 'startTime' || fieldName === 'endTime') {
          fieldValue = convertTo24HourFormat(fieldValue);
        }
        if (fieldName === 'maxOccupancy' || fieldName === 'continuousDrivingTimeInSeconds') {
          fieldValue = Number(fieldValue);
        }

        feature[fieldName] = fieldValue;
      });

      return {
        featureType,
        feature,
        enableFlag: featureData.enableFlag,
      };
    });

    // .filter(feature => feature.enableFlag); // only include enabled features

    const payload = {
      fleetId,
      featureList,
    };

    console.info('Saving payload:', payload);

    fetchUserSettingDataSaveData(payload);

    setTimeout(() => {
      UserSettingFetchRequestData({
        fleetId: user?.authorities === 'ROLE_SUPER_ADMIN' ? selectedUser?.id : user?.customer_id,
      });
    }, 500);
  };

  console.info(settingData, 'settingData');

  return (
    <>
      <Typography variant="h6" fontSize="18px" fontWeight={600} lineHeight="36px">
        User Settings
      </Typography>
      <div
        className="w-full grid grid-cols-1 md:grid-cols-2 gap-4"
        style={{
          pointerEvents:
            user?.authorities === 'ROLE_SUPER_ADMIN'
              ? selectedCompany && selectedUser
                ? 'auto'
                : 'none'
              : 'auto',
          opacity: user?.authorities === 'ROLE_SUPER_ADMIN' ? (selectedCompany && selectedUser ? 1 : 0.5) : 1,
        }}
      >
        {Object.keys(settingData).length > 0 &&
          Object.keys(settingData).map((key: string) => (
            <FeatureSection
              key={key}
              name={key}
              feature={settingData[key]}
              isSuperAdmin={isSuperAdmin}
              onToggleFeatureFlag={toggleFeatureFlag}
              onUpdateFieldValue={updateFieldValue}
            />
          ))}
      </div>
      <AlertToast
        open={toast.open}
        message={toast.message}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        type={toast.type as any}
      />
    </>
  );
};

export default UserAlertSettings;
